import {
  PusherActionType,
  PusherReduxAction,
} from '../../../../../../../../redux/pusher/PusherActions';
import { fetchEntry } from '../../timelineEntries/fetchEntry';
import { scheduleActions } from '../../../actions';
import { put, select } from 'redux-saga/effects';
import { AircraftContractTimelineEntry } from '../../../../../../../../common/types/timeline/AircraftContractTimelineEntry';
import { selectAircraftContractTimelineEntriesSaga } from '../../../selectors-saga';
import { AircraftTimelineEntryType } from '../../../../../../../../common/types/timeline/AircraftTimelineEntryType';
import { getRouter } from '../../../../../../../../redux/selectors';
import { RouterState } from 'connected-react-router';

export function* handleAircraftContractEntryUpdate(
  action: PusherReduxAction<PusherActionType.AIRCRAFT_CONTRACT_ENTRY_UPDATED>,
) {
  const { location } = (yield select(getRouter)) as RouterState;
  if (!location.pathname.includes('crew-scheduling-v3')) {
    return;
  }
  yield put(scheduleActions.reFetchAllEntries())

  try {
    const { payload } = action;

    const entry = (yield fetchEntry(
      AircraftTimelineEntryType.AircraftContract,
      payload.ID,
      true,
    )) as AircraftContractTimelineEntry;

    const existedEntries = yield* selectAircraftContractTimelineEntriesSaga();
    const updatedEntries = existedEntries.map(e => {
      if (e.ID === payload.ID) {
        return entry;
      }
      return e;
    });

    yield put(scheduleActions.setState({ aircraftContractTimelineEntries: updatedEntries }));
  } finally {
    yield put(scheduleActions.reFetchAllEntries())
  }
}
